import { Incidence } from './../../models/incidence';
import { IncidenceBuilder } from './../../models/builders/incidence.builder';
import { CauseBuilder } from '../../models/builders/cause.builder';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IncidenceTypeBuilder } from '../../models/builders/incidence-type.builder';

const getIncidenceBody = (incidence: Incidence) => ({
  schedulerTaskHash: incidence.schedulerTaskHash,
  finished: incidence.finished,
  recoverable: incidence.recoverable,
  scrapped: incidence.scrapped,
  cause: incidence.cause,
  causeDescription: incidence.causeDescription,
  observation: incidence.observation,
  userErpCode: incidence.userErpCode,
  type: incidence.type,
  isImputable: incidence.isImputable,
});

@Injectable()
export class IncidenceApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}incidences`;
  }


  getSchedulerTaskIncidencesNotSendBySchedulerTask(schedulerTaskHash) {
    return this.httpClient.get(`${this.apiUrl}/not-send-pause/${schedulerTaskHash}`)
      .pipe(
        map(IncidenceBuilder.fromList)
      );
  }

  getSchedulerPausedTaskIncidencesNotSendBySchedulerTask(schedulerTaskHash) {
    return this.httpClient.get(`${this.apiUrl}/paused/${schedulerTaskHash}`)
      .pipe(
        map(IncidenceBuilder.fromList)
      );
  }


  getSchedulerTaskIncidencesBySchedulerTask(schedulerTaskHash) {
    return this.httpClient.get(`${this.apiUrl}/${schedulerTaskHash}`)
      .pipe(
        map(IncidenceBuilder.fromList)
      );
  }

  getCauses() {
    return this.httpClient.get(`${this.apiUrl}/causes`)
      .pipe(
        map(CauseBuilder.fromList)
      );
  }

  saveIncidence(incidence: Incidence) {
    return this.httpClient.post(`${this.apiUrl}`, getIncidenceBody(incidence))
      .pipe(
        map(IncidenceBuilder.fromJson)
      );
  }

  editIncidence(incidence: Incidence) {
    return this.httpClient.put(`${this.apiUrl}/${incidence.hash}`, getIncidenceBody(incidence))
      .pipe(
        map(IncidenceBuilder.fromJson)
      );
  }

  delete(hash: Incidence) {
    return this.httpClient.delete(`${this.apiUrl}/${hash}`);
  }

  getIncidenceTypes() {
    return this.httpClient.get(`${this.apiUrl}/incidence-types`)
      .pipe(
        map(IncidenceTypeBuilder.fromList)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/incidence-api.service.ts